
/**
 * Removes leading zeros from a numeric string.
 * Preserves values like "0", "0.", and "0.5".
 */
export const sanitizeNumericInput = (raw: string): string => {
  // Remove non-numeric/non-dot characters
  let clean = raw.replace(/[^0-9.]/g, "");
  
  // Only allow one decimal point
  const parts = clean.split(".");
  if (parts.length > 2) {
    clean = parts[0] + "." + parts.slice(1).join("");
  }

  // Strip leading zeros unless it's "0" or starts with "0."
  if (clean.length > 1 && clean.startsWith("0") && clean[1] !== ".") {
    clean = clean.replace(/^0+/, "");
    if (clean === "" || clean.startsWith(".")) clean = "0" + clean;
  }

  return clean || "0";
};

/**
 * Parses a string to a number, returning null if empty or invalid.
 */
export const parseToNumber = (s: string): number | null => {
  if (s === "") return null;
  const n = parseFloat(s);
  return isNaN(n) ? null : n;
};
